import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react'
import { api } from '../utils/api'

// How many Reverb Buyer Offers wait for our reply. Loaded ONCE for the whole
// app and shared, so the menu badge and the Reverb Offers tab never disagree.
// Spec: audiotrader-prism specs/specs_20261015_reverb_offers.md

// Offers expire after 24h; the backend mirror refreshes every 5 minutes.
export const REVERB_OFFERS_REFRESH_MS = 5 * 60 * 1000

const NOT_PROVIDED = { awaitingCount: 0, refresh: async () => {} }

const ReverbOffersContext = createContext(NOT_PROVIDED)

export function ReverbOffersProvider({ enabled, children }) {
  const [awaitingCount, setAwaitingCount] = useState(0)

  const refresh = useCallback(async () => {
    try {
      const { count = 0 } = await api.get('/api/orders/reverb-offers/awaiting-count')
      setAwaitingCount(count)
    } catch (error) {
      // Keep the last known count: a failed load must not hide waiting offers.
      console.error('Failed to load the Reverb offer count:', error)
    }
  }, [])

  useEffect(() => {
    if (!enabled) return undefined
    refresh()
    const interval = setInterval(refresh, REVERB_OFFERS_REFRESH_MS)
    return () => clearInterval(interval)
  }, [enabled, refresh])

  const value = useMemo(() => ({ awaitingCount, refresh }), [awaitingCount, refresh])

  return <ReverbOffersContext.Provider value={value}>{children}</ReverbOffersContext.Provider>
}

export function useReverbOffers() {
  return useContext(ReverbOffersContext)
}
